import React, { useEffect, useRef, useState } from 'react'
import { DATA_TYPE } from '../WhiteLabelFirmsTable';
import { updateWlfFee } from '../api';
import { useSelector } from 'react-redux';
import { Status } from '@ca/wrap-sdk/src/response';
import { Spinner } from '../../../funcs/utils';


const currencyFormat = (data) => {
    const value = data.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })

    return <div>{value}</div>
}

// limit width
// handle submit
const inputFieldFormat = (dataType, data, wlfId) => {
    const [isEdit, setIsEdit] = useState(false);
    const [displayValue, setDisplayValue] = useState(data);
    const [value, setValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef(null);
    const token = useSelector(state => state.user.token);

    useEffect(() => {
        if(ref.current) {
            ref.current.focus();
        }
    }, [isEdit])

    const reset = () => {
        setValue(data);
        setIsEdit(false);
    }

    const handleOnChange = (e) => {
        e.preventDefault();
        const input = e.target.value;

        const regex = /^\d+\.?\d*$/;
        if(input !== '' && !regex.test(input)) {
            return;
        }

        setValue(input);
    }

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            setDisplayValue(value);
            setIsEdit(false);

            const updates = {};

            if(dataType === DATA_TYPE.ADVISORY) {
                updates.advisory_fee = value;
            } else if (dataType === DATA_TYPE.SUB_ADVISORY) {
                updates.sub_advisory_fee = value;
            }
            
            const updateWlfFeeResponse = await updateWlfFee(token, wlfId, updates);
            if(updateWlfFeeResponse.status !== Status.OK) {
                throw new Error(updateWlfFeeResponse.error);
            }
        } catch (error) {
            setDisplayValue(data);
            console.log('Error when calling updateWlfFee: ', error);
        } finally {
            setIsLoading(false);
        }
    }
    const handleOnKeyDown = (e) => {
        if(e.key === 'Enter') {
            handleSubmit();
        } else if (e.key === 'Escape') {
            reset();
        }
    }

    const handleOnBlur = () => {
        reset();
    }

    const handleOnClick = () => {
        setIsEdit(true);
    }

    if(!isEdit) {
        return (
            <React.Fragment >
                {isLoading && 
                    <div style={{ display: 'flex', justifyContent:'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, height: '100vh', width: '100vw', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
                        <Spinner size={"3rem"} />
                    </div>
                }
                <div>
                    <div style={{ width: '100px' }} onClick={handleOnClick}>{`${displayValue} bp`}</div>
                </div>
            </React.Fragment>
        )
    }

    return (
        <div style={{ display: 'flex', gap: '8px', width: '100px' }}>
            <input style={{ width: '100%' }} ref={ref} type='text' value={value} onChange={handleOnChange} onBlur={handleOnBlur} onKeyDown={handleOnKeyDown}/>
            <div>bp</div>
        </div>

    )
}

const phoneFormat = (phone) => {
    // Remove everything except digits
    const digits = phone.replace(/\D/g, '');

     // Trim country code if it's +1 or 1 (for US numbers)
    const cleaned = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

    const areaCode = cleaned.slice(0, 3);
    const centralOffice = cleaned.slice(3, 6);
    const lineNumber = cleaned.slice(6);

    if(cleaned.length !== 10) {
        return (
            <div>
                <div style={{ textWrap: 'nowrap' }}>{`${areaCode} ${centralOffice}-${lineNumber}`}</div>
                <div style={{ color: 'red' }}>Invalid US Phone Number!</div>
            </div>
        )
    }

    return (
        <div style={{ textWrap: 'nowrap' }}>{`${areaCode} ${centralOffice}-${lineNumber}`}</div>
    );
}

const dataFormatter = (dataType, data, wlfId) => {
    let value = <div>{data}</div>;

    switch(dataType) {
        case DATA_TYPE.CURRENCY:
            const amount = data ? data : 0;
            value = currencyFormat(amount);
            break;
        
        case DATA_TYPE.ADVISORY:
            value = inputFieldFormat(DATA_TYPE.ADVISORY, data, wlfId);
            break;
        case DATA_TYPE.SUB_ADVISORY:
            value = inputFieldFormat(DATA_TYPE.SUB_ADVISORY, data, wlfId);
            break;
        case DATA_TYPE.PHONE:
            value = phoneFormat(data);
            break;

        default:
            break;
    }

    return value;
}

const WhiteLabelFirmsData = ({ dataType, data, wlfId }) => {
    return (
        <React.Fragment>
            {dataFormatter(dataType, data, wlfId)}
        </React.Fragment>
    )
}

export default WhiteLabelFirmsData;
